import { Component, OnInit } from '@angular/core';
import {Router} from '@angular/router';
import { GenericServiceService } from '../../services/generic-service.service';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss']
})
export class LoginComponent implements OnInit {
  model: any = {};
  constructor(private router: Router,
    private genericServices: GenericServiceService,
     ) { }

  ngOnInit() {
  }

  onSubmit() {
    debugger;
    this.genericServices.SignIn(this.model).subscribe((Data: any) => {
      console.log('daggarpong', Data);
        // sessionStorage.setItem('AuthToken', Data.AuthToken);
        // sessionStorage.setItem('FullName', Data.FullName);
        localStorage.setItem('fullName', Data.FullName);
        localStorage.setItem('DisptacherId', Data.Id);
        this.router.navigate(['/dashboard']);

    }, error => {
      console.log(error.error.Message);
    });
  }

}
